// import { useEffect, useState } from 'react';
import ResponseHandlerService from '../services/ResponseHandlerService';
import useObservable from './UseObservable';

/**
   * useResponseHandler is a custom hook that
   * debugs any error that is not contained in an endpoint call.
   */
const responseHandler = ResponseHandlerService.getInstance();

function useResponseHandler() {
  const [error] = useObservable(responseHandler.getError());
  const [errors = {}] = useObservable(responseHandler.getErrors());
  const [success] = useObservable(responseHandler.getSuccess());

  const clearError = () => responseHandler.clearError();
  const clearAllErrors = () => responseHandler.clearErrors();

  return {
    error,
    errors,
    errorStatus: error?.response?.status,
    success,
    clearError,
    clearAllErrors,
  };
}

export default useResponseHandler;
